module.exports = __webpack_public_path__ + "img/ah-logo.693c0c56.png";